import type { EditSchemaDefinition } from "@/shared/components/CRUD/types";
import { CRUD } from "@/shared/components";
import { PaymentsListQuery, PaymentShowQuery } from "@/admin/entities/payments";
import { PaymentDetails } from "../domains";
import {
  usePaymentsManagement,
  type PaymentRow,
  PaymentsSchemas,
} from "../model";

const getPaymentTitle = () => "Платёж";

const editSchema: EditSchemaDefinition = {
  details: {
    label: "Детали платежа",
    type: "show" as const,
    getTitle: getPaymentTitle,
    showComponent: PaymentDetails,
    showQuery: PaymentShowQuery,
  },
};

/**
 * Реестр платежей. Только просмотр — редактирования, создания и
 * удаления нет, возврат оформляется отдельной кнопкой в строке.
 */
export function Payments() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    usePaymentsManagement();

  return (
    <CRUD<PaymentRow>
      listQuery={PaymentsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={PaymentsSchemas.filterSchema}
      editSchema={editSchema}
      texts={texts}
      persistFilters
      hideCreateButton
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
